export const DIGITAL_DELIVERY_ONLY_MESSAGE = 'Digital items are delivered for free and typically arrive within 5 minutes of successful completion of your order.';
export const NO_FAVORITES_MESSAGE = 'Whoopsie Daisy! You haven\'t added any items to your Favorites yet.';
